import { AnalysisStatus, FileUploadStatus } from "@explorance/mly-types";

export const analysisJobInProgress = (analysis) =>
  [AnalysisStatus.InProgress].includes(analysis.analysisStatus) ||
  [FileUploadStatus.Uploading].includes(analysis.fileUploadStatus);
